import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createMonthlyReportPdfService } from "../service/createMonthlyReportPdf.service";

const initialState = {
  id: null,
  document: null,
  date: "",
};

export const useMonthlyReportPdfCommand = (refresh) => {
  const fetchData = useFetch();
  const [monthlyReportPdf, setMonthlyReportPdf] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChange = ({ name, value }) => {
    setMonthlyReportPdf((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      hasErrors: false,
      errors: {
        ...prev.errors,
        [name]: null,
      },
    }));
  };

  const createMonthlyReportPdf = async () => {
    setLoading(true);
    try {
      if (!validations(monthlyReportPdf)) {
        return;
      }

      const formData = new FormData();
      formData.append("date", monthlyReportPdf.date);
      formData.append("file", monthlyReportPdf.document);

      const response = await createMonthlyReportPdfService(fetchData)(
        formData
      );

      Swal.fire({
        title: "Éxito",
        text: "El informe mensual en PDF se creó correctamente.",
        icon: "success",
      });
      setMonthlyReportPdf(initialState);
      refresh?.();
      return response;
    } catch (error) {
      console.error("Error creating monthly report PDF:", error);
      setErrors({
        hasErrors: true,
        errors: error.response?.data || {
          general: "An error occurred while creating the report.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (data) => {
    const newErrors = {};
    if (!data.date) {
      newErrors.date = "La fecha es requerida.";
    }
    if (!data.document) {
      newErrors.document = "El documento es requerido.";
    }

    if (data.document && data.document.type !== "application/pdf") {
      newErrors.document = "El archivo debe ser un PDF.";
    }

    const hasErrors = Object.keys(newErrors).length > 0;
    setErrors({
      hasErrors,
      errors: newErrors,
    });
    return !hasErrors;
  };

  return {
    monthlyReportPdf,
    loading,
    errors,
    handleChange,
    createMonthlyReportPdf,
  };
};
